import AddProviderModal from './AddProviderModal'
import EditProviderModal from './EditProviderModal'
import MergeProvidersModal from './MergeProvidersModal'

import { heapEvent } from '@equipmentshare/heaper'

import { ActionModalType } from '../../../../../components/ActionModal'

export type Provider = {
  id: number,
  name: string,
}

export function getAddModal(): ActionModalType {
	return {
		component: AddProviderModal,
		label: 'Add Manufacturer',
		onXClick: () => heapEvent( 'Inventory - Add Manufacturer Modal - Click - X button', {} )
	}
}

export function getEditModal( provider: Provider, onMerge: () => void ): ActionModalType {
	return {
		component: EditProviderModal,
		componentProps: { provider, onMerge },
		label: 'Edit Manufacturer',
		onXClick: () => heapEvent( 'Inventory - Edit Manufacturer Modal - Click - X button', {} )
	}
}

export function getMergeModal( provider: Provider ): ActionModalType {
	return {
		component: MergeProvidersModal,
		componentProps: { provider },
		label: 'Merge Manufacturers',
		onXClick: () => heapEvent( 'Inventory - Merge Manufacturers Modal - Click - X button', {} )
	}
}
